module.exports = __webpack_public_path__ + "static/media/play.83d9b70f.png";